<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="selected_rate_card != null"
>
    <v-card>
        <v-card-title>Credit</v-card-title>

        <v-card-text>
            <p><b>Credit Setup Fees</b></p>
            
            <v-checkbox
                label="Issue a full credit for any setup fees"
                v-model="selected_rate_card.credit_setup.enabled"
            />

            <m-edit-message-patterns-compact
                label="Setup Fee Credit Memo"
                v-model="selected_rate_card.credit_setup.memo_patterns"
                context="credit-memo-setup"
            />

            <p
                style="margin-top: 15px"
            >
                <b>Credit Recurring Fees</b>
            </p> 

            <v-checkbox
                label="Issue a full credit for any recurring fees (during the period)"
                v-model="selected_rate_card.credit_recurring_fee.enabled"
            />

            <m-edit-date
                label="Credit Start Date"
                v-model="selected_rate_card.credit_recurring_fee.start"
            />

            <m-edit-date
                label="Credit Stop Date"
                v-model="selected_rate_card.credit_recurring_fee.stop"
            />

            <m-edit-message-patterns-compact
                label="Recurring Fee Credit Memo"
                v-model="selected_rate_card.credit_recurring_fee.memo_patterns"
                context="credit-memo-recurring"
            />

            
        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                @click="onClickCommerce7Promo2025"
            >
                Commerce7 2025 Promo
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');
export default {

    data() {
        return {
            dialog: false,
            selected_rate_card: null,
        }
    },

    methods: {

        showDialog(selected_rate_card)
        {
            this.selected_rate_card = _.cloneDeep(selected_rate_card);
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.selected_rate_card);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickCommerce7Promo2025()
        {
            this.selected_rate_card.credit_setup.enabled = true;
            this.selected_rate_card.credit_setup.memo_patterns = ['Commerce7 is paying all of your setup fees'];


            this.selected_rate_card.credit_recurring_fee.enabled = true;
            this.selected_rate_card.credit_recurring_fee.start = this.selected_rate_card.billing_start_date ?? Time.toISODateString(new Date());

            let stop_date = new Date(this.selected_rate_card.credit_recurring_fee.start+'T16:00:00.000Z');
            stop_date.setDate(stop_date.getDate() + 94);

            this.selected_rate_card.credit_recurring_fee.stop =  Time.toISODateString(stop_date);
            this.selected_rate_card.credit_recurring_fee.memo_patterns = ['Commerce7 is paying your monthly subscription fees through {stop-date}'];
        }
    },
}
</script>

<style lang="scss" scoped>
</style>